import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {RestService} from "../../core/services/rest.service";
import {VinculoNBSIndicadorOperacao} from "../../../classes/vinculo.nbs.indicador.operacao";

@Injectable()
export class VinculoNbsIndicadorOperacaoService {

  constructor(private restService: RestService){
  }

  buscaVinculoNBSIndicador(nbs: number, atividadeNacional: number): Observable<VinculoNBSIndicadorOperacao[]> {
    return this.restService.get("/vinculonbsindicadoroperacao/vinculoIndicador/"+ nbs+"/"+ atividadeNacional, {responseType: VinculoNBSIndicadorOperacao});
  }

}
